import BaseButtonGroup from '@material-ui/core/ButtonGroup'

const ButtonGroup = BaseButtonGroup

export default ButtonGroup
